import { IAttribute, IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ExecuteSSISPackageParameterConfig } from './ssis.activity.parameter-config';

@Metamodel.model({})
export class ExecuteSSISPackageConnectionManagerParameterConfig extends ExecuteSSISPackageParameterConfig {
    public static readonly MODEL: IModel;
    public static readonly VALUE: IAttribute;
    public static readonly SCOPE: IAttribute;
    public static readonly DELETABLE: IAttribute;
    public static readonly CONNECTION_MANAGER: IAttribute;

    public index: number = 0;

    @Metamodel.attribute({
        association: 'CONNECTION_MANAGER'
    })
    public connectionManager: string;

}
